export default {
  en: { id: 'en' },
  es: { id: 'es' },
  english: { id: 'english' },
  spain: { id: 'spain' },
  th: { id: 'th' },
  pt: { id: 'pt' },
  thai: { id: 'thai' },
  portugal: { id: 'portugal' },
  russian: { id: 'russian' },
  ru: { id: 'ru' },
  uk: { id: 'uk' },
  ukrainian: { id: 'ukrainian' },
  no: { id: 'no' },
  norwegian: { id: 'norwegian' },
  pl: { id: 'pl' },
  polish: { id: 'polish' },
}
